/**
 * @param {Object} param0
 * @param {import("axios").AxiosInstance} param0.repository
 */
export default function actions({ repository } = {}) {
  const path = `/v2/organization/distribution`;
  const fake_path = `/v2/organization/publisher/course`;

  return {
    /**
     *
     * @param {Object} param0
     * @param {String} param0.type Public, Published is only support for right now
     */
    async get({ type } = {}) {
      if (type == "approved") {
        return repository
          .get(fake_path, {
            params: {
              type: "published"
            }
          })
          .then(response => {
            return Promise.resolve(response.data.object);
          });
      }
      return repository
        .get(path, {
          params: {
            type: type
          }
        })
        .then(response => {
          return Promise.resolve(response.data.object);
        });
    },
    /**
     * Update a document
     * @param {Object} param0
     * @param {String} param0.id
     * @param {Oject} param0.document
     * @param {String} param0.type
     */
    async update({ id, document, type } = {}) {
      return repository.put(
        path,
        { docs: [{ ...document, _id: id }] },
        {
          params: {
            type: type
          }
        }
      );
    },
    /**
     *
     * @param {Object} param0
     * @param {String} param0.type
     * @param {String} param0.course
     * @param {Object} param0.properties
     * @param {Number} param0.properties.price: this.form.properties.priceObject.price,
     * @param {Boolean} param0.properties.requireAccessCode: this.form.properties.requireAccessCode,
     * @param {String} param0.properties.accessCode: this.form.properties.accessCode,
     * @param {Boolean} param0.properties.limitCopies: false,
     * @param {Number} param0.properties.copies: 100,
     * @param {Boolean} param0.properties.hidden: this.form.properties.hidden
     */
    async create({ type, course, properties } = {}) {
      const response = await repository.post(
        path,
        { cids: [course], properties: properties },
        { params: { type: type } }
      );
      return Array.isArray(response.data.object) ? response.data.object[0] : {};
    }
  };
}
